import { useEffect, useState } from "react";
import servicosAtribuicao from "../servicos/servicos-atribuicao";
import servicosSolicitacao from "../servicos/servicos-solicitacao";
import { useContext } from "react";
import AuthContext from "../servicos/autorizacao/AuthContex";
import NavMenu from "./components/Nav";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import { localizedTextsMap } from "../utils/localizedTextsMap";
import NavMobile from "./components/NavMobile";
import Spinner from "./components/Spinner";

const columnsSolicitacao = [
  { field: "id_solicitacao", headerName: "ID", width: 90 },
  {
    field: "Produto[0].nome",
    headerName: "Produto",
    width: 100,
    editable: true,
    valueGetter: (params) => {
      return params.row.Produto[0].nome
    }
  },
  {
    field: "Produto[0].milhas",
    headerName: "Qtd Milhas",
    width: 100,
    editable: false,
    valueGetter: (params) => {
      return params.row.Produto[0].milhas
    }
  },
  {
    field: "status",
    headerName: "Status",
    width: 100,
    editable: false
  },
  {
    field: "observacao",
    headerName: "Observação",
    width: 150,
    editable: true
  },
  {
    field: "data_solicitacao",
    headerName: "Data Solicitação",
    width: 120,
    editable: false,
    valueGetter: (params) => {
      if (params.value !== null) {
        let aux = String(params.row.data_solicitacao).split("-");
        let ano = aux[0];
        let mes = aux[1];
        let dia = aux[2];
        let dataFormatada = `${dia}-${mes}-${ano}`;
        return dataFormatada;
      }
    }
  },
  {
    field: "data_entrega",
    headerName: "Data Entrega",
    width: 120,
    editable: false,
    valueGetter: (params) => {
      if (params.value !== null) {
        let aux = String(params.row.data_entrega).split("-");
        let ano = aux[0];
        let mes = aux[1];
        let dia = aux[2];
        let dataFormatada = `${dia}-${mes}-${ano}`;
        return dataFormatada;
      }
    }
  },
  {
    field: "responsavel",
    headerName: "Entregue por",
    width: 180,
    editable: true
  },
];

const columnsAtribuicoes = [
  { field: "id_milhas", headerName: "ID", width: 45 },
  {
    field: "Motivo[0].descricao",
    headerName: "Motivo",
    width: 250,
    editable: false,
    valueGetter: (params) => {
      return params.row.Motivo[0].descricao
    }
  },
  {
    field: "Motivo[0].qtd_milhas",
    headerName: "Qtd Milhas",
    width: 100,
    editable: false,
    valueGetter: (params) => {
      return params.row.Motivo[0].qtd_milhas
    }
  },
  {
    field: "data",
    headerName: "Data Atribuição",
    valueGetter: (params) => {
      let aux = String(params.value).split("-");
      let ano = aux[0];
      let mes = aux[1];
      let dia = aux[2];
      let dataFormatada = `${dia}-${mes}-${ano}`;
      return dataFormatada;
    }
  }
];

const Historico = () => {
  const { user } = useContext(AuthContext);
  const [minhasAtribuicoes, setMinhasAtribuicoes] = useState([]);
  const [minhasSolicitacoes, setMinhasSolicitacoes] = useState([]);
  const [showEntradas, setShowEntradas] = useState(true);
  const [showSaidas, setShowSaidas] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const handleShowEntradas = () => {
    setShowEntradas(true);
    setShowSaidas(false);
  }
  const handleShowSaidas = () => {
    setShowSaidas(true);
    setShowEntradas(false);
  }

  useEffect(() => {
    setIsLoading(true);
    servicosAtribuicao.listarPorIdColaborador(user.id)
      .then(response => {
        if (response.status === 200) {
          const items = []
          response.data.allRegister.forEach(element => {
            if(!String(element.Motivo[0].descricao).includes("AUMENTO") && !String(element.Motivo[0].descricao).includes("DIMINUICAO")){
              items.push(element)
            }
          });
          setMinhasAtribuicoes(items);
          setTimeout(() => {
            setIsLoading(false);
          }, 1000);

        }
      }).catch(error => {
        console.log(error);
      })
  }, [user.id]);

  useEffect(() => {
    setIsLoading(true);
    servicosSolicitacao.minhasSolicitacoes(user.id)
      .then(response => {
        if (response.status === 200) {
          const items = []
          response.data.forEach(element => {
            if (element.status === 'finalizado') {
              items.push(element)
            }
          });
          setMinhasSolicitacoes(items);
          setTimeout(() => {
            setIsLoading(false);
          }, 1000);

        }
      }).catch(error => {
        console.log(error);
      })
  }, [user.id]);


  const styleH3 = {
    color: "#753BBD",
    fontSize: "24px"
  }


  return <>
    <NavMenu />
    {isLoading ? <div className="container mt-5 d-flex justify-content-center align-items-center"><Spinner mensagem="Carregando histórico de milhas" /></div> : <div className="container " >
      <h3 style={styleH3} className="text-center subtitulo">Histórico de Milhas</h3>
      <div className=" text-center mt-3 mb-4">
        <button className="btn-movimetacao" type="button" onClick={handleShowEntradas}>Entradas</button>
        <button type="button" className="btn-movimetacao ms-2" onClick={handleShowSaidas}>Saídas</button>
      </div>
      {showEntradas && <div className="d-flex justify-content-center align-items-center row " >

        <h3 className="">Entradas</h3>
        <Box sx={{ height: 630, width: 1300, }}>
          <DataGrid
            style={{ borderRadius: "20px" }}
            localeText={localizedTextsMap}
            rows={minhasAtribuicoes}
            columns={columnsAtribuicoes}
            pageSize={10}
            rowsPerPageOptions={[10]}
            disableSelectionOnClick
            getRowId={(row) => row.id_milhas}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0 ? 'Mui-even' : 'Mui-odd'
            }
          />
        </Box>



      </div>
      }
      {showSaidas && <div className="d-flex justify-content-center align-items-center row">
        <h3 className="">Saídas</h3>
        <Box sx={{ height: 650, width: 1300, marginBottom: 15 }}>
          <DataGrid
            localeText={localizedTextsMap}
            rows={minhasSolicitacoes}
            columns={columnsSolicitacao}
            pageSize={10}
            rowsPerPageOptions={[10]}
            getRowId={(row) => row.id_solicitacao}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0 ? 'Mui-even' : 'Mui-odd'
            }
          />
        </Box>


      </div >}
    </div>}



    <NavMobile />
  </>
}

export default Historico;